import React from 'react';

import {
  AllItemsIcon,
  EverydayDealsIcon,
  EndingSoonIcon,
  BogoIcon,
  BundlesIcon,
} from 'src/assets/specials-filter-icons';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useHideSalesLanguage } from 'src/hooks/use-hide-sales-language';
import useUI from 'src/hooks/use-ui';
import { specialsMatchFilterKey, SpecialFilterKey } from 'src/hooks/use-special-filter-param';
import { SpecialMenuCard } from 'src/gql/graphql';

import { ChipsGrid, ChipLink, ChipLabel, ChipIcon } from './styles';

type ChipDefinition = {
  key: SpecialFilterKey;
  label: string;
  complianceLabel: string;
  icon: React.ComponentType;
};

const CHIP_DEFINITIONS: ChipDefinition[] = [
  { key: 'all', label: 'All Items On Special', complianceLabel: 'All Items On Offer', icon: AllItemsIcon },
  { key: 'everyday', label: 'Everyday Deals', complianceLabel: 'Everyday Deals', icon: EverydayDealsIcon },
  { key: 'ending-soon', label: 'Ending Soon', complianceLabel: 'Ending Soon', icon: EndingSoonIcon },
  { key: 'bogo', label: 'BOGO', complianceLabel: 'BOGO', icon: BogoIcon },
  { key: 'bundles', label: 'Bundles', complianceLabel: 'Bundles', icon: BundlesIcon },
];

type SpecialsFilterChipsProps = {
  specials: SpecialMenuCard[];
};

export function SpecialsFilterChips({ specials }: SpecialsFilterChipsProps): JSX.Element | null {
  const { dispensary } = useDispensary();
  const { dispensaryRootUrl } = useUI();
  const hideSalesLanguage = useHideSalesLanguage();

  const visibleChips = CHIP_DEFINITIONS.filter((chip) => specialsMatchFilterKey(chip.key, specials));

  if (!dispensary || visibleChips.length === 0) {
    return null;
  }

  const { cName } = dispensary;

  const ariaLabel = hideSalesLanguage ? 'Offer filters' : 'Special filters';

  return (
    <ChipsGrid aria-label={ariaLabel} data-testid='specials-filter-chips'>
      {visibleChips.map((chip) => {
        const label = hideSalesLanguage ? chip.complianceLabel : chip.label;
        const href = `/${dispensaryRootUrl}/${cName}/products?specialFilter=${chip.key}`;

        return (
          <ChipLink key={chip.key} href={href}>
            <ChipIcon aria-hidden='true'>
              <chip.icon />
            </ChipIcon>
            <ChipLabel>{label}</ChipLabel>
          </ChipLink>
        );
      })}
    </ChipsGrid>
  );
}
